var _path, _path2, _mask, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountpayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.7474 5.00348C2.74623 3.76001 3.75393 2.75136 4.9974 2.75136H19.0046C20.2474 2.75136 21.2548 3.75903 21.2546 5.00187L21.2514 19.0019C21.2511 20.2443 20.2438 21.2514 19.0014 21.2514H5.01059C3.76878 21.2514 2.76176 20.2453 2.76059 19.0035L2.7474 5.00348Z",
    stroke: "#404553",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75423 9.75832C2.75044 8.65108 3.64697 7.75146 4.75422 7.75146H19.2532C20.3584 7.75146 21.2541 8.6479 21.2532 9.75311C21.2523 10.857 20.3571 11.7515 19.2532 11.7515H4.75422C3.65233 11.7515 2.75801 10.8602 2.75423 9.75832Z",
    fill: "#FEEE00",
    stroke: "#404553",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00432 16.7609C5.99907 16.343 6.33637 16.0015 6.75427 16.0015L12.2532 16.0015C12.6683 16.0015 13.0044 16.3386 13.0032 16.7537C13.0019 17.1671 12.6665 17.5015 12.2532 17.5015H6.75426C6.34373 17.5015 6.00948 17.1714 6.00432 16.7609Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75427 17.5015H12.2532V14.5015H6.75427V17.5015ZM12.2532 16.0015H6.75426V19.0015H12.2532V16.0015ZM6.75426 16.0015C7.1648 16.0015 7.49905 16.3315 7.50421 16.742L4.50444 16.7797C4.51992 18.0113 5.52265 19.0015 6.75426 19.0015V16.0015ZM11.5032 16.7492C11.5044 16.3359 11.8399 16.0015 12.2532 16.0015V19.0015C13.4932 19.0015 14.4994 17.9982 14.5032 16.7583L11.5032 16.7492ZM12.2532 17.5015C11.8381 17.5015 11.5019 17.1643 11.5032 16.7492L14.5032 16.7583C14.5069 15.513 13.4985 14.5015 12.2532 14.5015V17.5015ZM6.75427 14.5015C5.50057 14.5015 4.48869 15.5261 4.50444 16.7797L7.50421 16.742C7.50946 17.1599 7.17216 17.5015 6.75427 17.5015V14.5015Z",
    fill: "#404553",
    mask: "url(#path-3-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountpayment);
export default __webpack_public_path__ + "static/media/accountpayment.30fe890d.svg";
export { ForwardRef as ReactComponent };